<script lang="ts" module>
  import { tv } from 'tailwind-variants';

  import BasePill, { type BasePillProps } from './BasePill.svelte';

  export type Variant =
    | 'wording'
    | 'phrases'
    | 'warning'
    | 'info'
    | 'spelling'
    | 'grammar'
    | 'fixed'
    | 'recommendation';

  export interface BrandFitResultProps {
    children: BasePillProps['children'];
    variant: Variant;
  }
</script>

<script lang="ts">
  let { ...props }: BrandFitResultProps = $props();

  const styles = tv({
    base: '',
    variants: {
      variant: {
        wording: 'bg-brandfit-wording',
        phrases: 'bg-brandfit-compositions',
        warning: 'bg-brandfit-warning',
        info: 'bg-brandfit-info',
        spelling: 'bg-brandfit-spelling',
        grammar: 'bg-brandfit-grammar',
        fixed: 'bg-brandfit-fixed',
        recommendation: 'bg-brandfit-accent1',
      },
    },
  });
</script>

<BasePill class={styles({ variant: props.variant })}>{@render props.children()}</BasePill>
